export default "__VITE_ASSET__BAlWBqv9__"